import React, { ReactElement } from 'react';
import { TextInput, Keyboard } from 'react-native';
import { useTranslation } from 'react-i18next';
import { getSearchInputStyles } from './styles';
import { SearchInputProps } from './types';

export const SearchInput = (props: SearchInputProps): ReactElement => {
    const { theme, handleSearchStringChange, searchString } = props;
    const styles = getSearchInputStyles(theme);
    const { t } = useTranslation();

    return (
        <TextInput
            value={searchString || ''}
            style={styles.container}
            placeholder={t('adobePrimetime.searchTVProvider') as string}
            placeholderTextColor={theme.color.contrast4}
            onChangeText={handleSearchStringChange}
            onSubmitEditing={Keyboard.dismiss}
            autoCapitalize="none"
        />
    );
};
